'use client'
import { Image } from '@chakra-ui/react'
import { forwardRef, LegacyRef } from 'react'

import { ImageVariantProps } from './ImageWithFallback.types'

export default forwardRef(function Img(
  props: ImageVariantProps,
  ref: LegacyRef<HTMLImageElement>
) {
  return <Image {...props} ref={ref} alt={props.alt} translate="no" />
})
